import ButtonHandler from './button-handler';
import CarouselHandler from './carousel-handler';
import ConditionHandler from './condition-handler';
import GoToHandler from './go-to-handler';
import MessageHandler from './message-handler';
import QuestionHandler from './question-handler';
import PluginHandler from './plugin-handler';
import InputFieldHandler from './input-field-handler';
import OpenHandler from './open-handler';
import EmbedHandler from './embed-handler';
import PlayerHandler from './player-handler';
import FormHandler from './form-handler';

export default [
  ButtonHandler,
  PluginHandler,
  CarouselHandler,
  ConditionHandler,
  GoToHandler,
  MessageHandler,
  QuestionHandler,
  InputFieldHandler,
  OpenHandler,
  EmbedHandler,
  PlayerHandler,
  FormHandler,
];
